var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9998 1.7998C12.9763 1.7998 16.1998 5.02335 16.1998 8.9998C16.1998 12.9763 12.9763 16.1998 8.9998 16.1998C5.02335 16.1998 1.7998 12.9763 1.7998 8.9998C1.7998 5.02335 5.02335 1.7998 8.9998 1.7998Z",
    fill: "#E5EDF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00771 7.23996C9.40771 7.23996 9.70371 6.96796 9.70371 6.59996C9.70371 6.21596 9.40771 5.95996 9.00771 5.95996C8.59971 5.95996 8.30371 6.21596 8.30371 6.59996C8.30371 6.96796 8.59971 7.23996 9.00771 7.23996Z",
    fill: "#6C7C83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5829 12.44V7.95996H8.41564V12.44H9.5829Z",
    fill: "#6C7C83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.7a03a53824211288e543bbfb6695ce21.svg";
export { ForwardRef as ReactComponent };